import { __decorate } from "tslib";
import { observer } from 'mobx-react';
import { TextField } from '../text-field/TextField';
import { $l } from '../locale-context';
import { FieldType } from '../data-set/enum';
let EmailField = class EmailField extends TextField {
    constructor() {
        super(...arguments);
        this.type = 'email';
    }
    getFieldType() {
        return FieldType.email;
    }
    get defaultValidationMessages() {
        const label = this.getProp('label');
        return {
            valueMissing: $l('EmailField', label ? 'value_missing' : 'value_missing_no_label', { label }),
            typeMismatch: $l('EmailField', 'type_mismatch'),
        };
    }
};
EmailField.displayName = 'EmailField';
EmailField = __decorate([
    observer
], EmailField);
export default EmailField;
